import { render, staticRenderFns } from "./PayTypeEdit.vue?vue&type=template&id=09468b3a"
import script from "./PayTypeEdit.vue?vue&type=script&lang=js"
export * from "./PayTypeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports